<p-dialog modal="true" styleClass="atlas-dialog-l" position="top" [closable]="true" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>{{ 'events.settings.items.event-item-details.label' | translate | titlecase }}</h4>
  </ng-template>
  <div>
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch">
      <button pButton type="button" [disabled]="exporting" class="atlas-btn atlas-btn-primary mb-15" (click)="exportItems()">
        {{ 'common.export' | translate | uppercase }}
        <wl-busy [show]="exporting"></wl-busy>
      </button>
    </div>
    <p-table [showGridlines]="true"
      [value]="searchResult?.Result"
      [rows]="searchParams ? searchParams.PageSize : 20"
      [totalRecords]="searchResult?.TotalCount"
      (onLazyLoad)="lazyLoad($event)"
      [lazyLoadOnInit]="false"
      [scrollable]="true"
      [loading]="loading"
      [lazy]="true"
    >
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pFrozenColumn style="min-width: 220px" pSortableColumn="Descr">
            {{ 'events.settings.items.event-item-details.event-item-name' | translate | titlecase }}
            <p-sortIcon field="Descr"></p-sortIcon>
          </th>
          <th style="min-width: 220px" pSortableColumn="LongDescription">
            {{ 'events.settings.items.event-item-details.long-description' | translate | titlecase }}
            <p-sortIcon field="LongDescription"></p-sortIcon>
          </th>
          <th style="min-width: 125px" pSortableColumn="AttendeesForItem">
            {{ 'events.settings.items.event-item-details.attendees' | translate | titlecase }}
            <p-sortIcon field="AttendeesForItem"></p-sortIcon>
          </th>
          <th style="min-width: 100px" pSortableColumn="IsPublic">
            {{ 'events.settings.items.event-item-details.public' | translate | titlecase }}
            <p-sortIcon field="IsPublic"></p-sortIcon>
          </th>
          <th style="min-width: 150px" pSortableColumn="IsSponsorShip">
            {{ 'events.settings.items.event-item-details.sponsorship' | translate | titlecase }}
            <p-sortIcon field="IsSponsorShip"></p-sortIcon>
          </th>
          <th style="min-width: 160px" pSortableColumn="MaxItemsAvail">
            {{ 'events.settings.items.event-item-details.max-items-avail' | translate | titlecase }}
            <p-sortIcon field="MaxItemsAvail"></p-sortIcon>
          </th>
          <th style="min-width: 170px" pSortableColumn="InvoiceDateDue">
            {{ 'events.settings.items.event-item-details.invoice-date-due' | translate | titlecase }}
            <p-sortIcon field="InvoiceDateDue"></p-sortIcon>
          </th>
          <th style="min-width: 160px" pSortableColumn="MembersOnly">
            {{ 'events.settings.items.event-item-details.members-only' | translate | titlecase }}
            <p-sortIcon field="MembersOnly"></p-sortIcon>
          </th>
          <th style="min-width: 220px" pSortableColumn="RestrictForAffiliations">
            {{ 'events.settings.items.event-item-details.restrict-for-aff' | translate | titlecase }}
            <p-sortIcon field="RestrictForAffiliations"></p-sortIcon>
          </th>
          <th style="min-width: 135px" pSortableColumn="StartDate">
            {{ 'events.settings.items.event-item-details.start-date' | translate | titlecase }}
            <p-sortIcon field="StartDate"></p-sortIcon>
          </th>
          <th style="min-width: 135px" pSortableColumn="EndDate">
            {{ 'events.settings.items.event-item-details.end-date' | translate | titlecase }}
            <p-sortIcon field="EndDate"></p-sortIcon>
          </th>
          <th style="min-width: 250px" pSortableColumn="ShowAsTeaserifRestricted">
            {{ 'events.settings.items.event-item-details.show-as-teaser' | translate | titlecase }}
            <p-sortIcon field="ShowAsTeaserifRestricted"></p-sortIcon>
          </th>
          <th style="min-width: 200px" pSortableColumn="TeaserMessage">
            {{ 'events.settings.items.event-item-details.teaser-message' | translate | titlecase }}
            <p-sortIcon field="TeaserMessage"></p-sortIcon>
          </th>
          <th style="min-width: 150px" pSortableColumn="MemberPrice">
            {{ 'events.settings.items.event-item-details.member-price' | translate | titlecase }}
            <p-sortIcon field="MemberPrice"></p-sortIcon>
          </th>
          <th style="min-width: 200px" pSortableColumn="NonMemberPrice">
            {{ 'events.settings.items.event-item-details.non-member-price' | translate }}
            <p-sortIcon field="NonMemberPrice"></p-sortIcon>
          </th>
          <th style="min-width: 300px" pSortableColumn="AllowRelateProfileMemberPrice">
            {{ 'events.settings.items.event-item-details.allow-related-profile' | translate | titlecase }}
            <p-sortIcon field="AllowRelateProfileMemberPrice"></p-sortIcon>
          </th>
          <th style="min-width: 220px" pSortableColumn="LimitPerRegistration">
            {{ 'events.settings.items.event-item-details.limit-registration' | translate | titlecase }}
            <p-sortIcon field="LimitPerRegistration"></p-sortIcon>
          </th>
          <th style="min-width: 220px" pSortableColumn="CreateSeparateAttendee">
            {{ 'events.settings.items.event-item-details.create-seperate-attendee' | translate | titlecase }}
            <p-sortIcon field="CreateSeparateAttendee"></p-sortIcon>
          </th>
          <th style="min-width: 220px" pSortableColumn="CreateSeparateAttendee">
            {{ 'events.settings.items.event-item-details.use-registration-date' | translate | titlecase }}
            <p-sortIcon field="CreateSeparateAttendee"></p-sortIcon>
          </th>
          <th style="min-width: 220px" pSortableColumn="CreateSeparateAttendee">
            {{ 'events.settings.items.event-item-details.days-after-use-registration-date' | translate | titlecase }}
            <p-sortIcon field="CreateSeparateAttendee"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-eventItem>
        <tr>
          <td pFrozenColumn>
            {{ eventItem.Descr }}
          </td>
          <td>
            {{ eventItem.LongDescription }}
          </td>
          <td>
            {{ eventItem.AttendeesForItem }}
          </td>
          <td>
            {{ eventItem.IsPublic }}
          </td>
          <td>
            {{ eventItem.IsSponsorShip }}
          </td>
          <td>
            {{ eventItem.MaxItemsAvail }}
          </td>
          <td>
            {{ eventItem.InvoiceDateDue | date: 'MM/dd/yyyy' }}
          </td>
          <td>
            {{ eventItem.MembersOnly }}
          </td>
          <td>
            {{ eventItem.RestrictForAffiliations }}
          </td>
          <td>
            {{ eventItem.StartDate | date: 'MM/dd/yyyy' }}
          </td>
          <td>
            {{ eventItem.EndDate | date: 'MM/dd/yyyy' }}
          </td>
          <td>
            {{ eventItem.ShowAsTeaserifRestricted }}
          </td>
          <td>
            {{ eventItem.TeaserMessage }}
          </td>
          <td>
            {{ eventItem.MemberPrice | currency }}
          </td>
          <td>
            {{ eventItem.NonMemberPrice | currency }}
          </td>
          <td>
            {{ eventItem.AllowRelateProfileMemberPrice }}
          </td>
          <td>
            {{ eventItem.LimitPerRegistration }}
          </td>
          <td>
            {{ eventItem.CreateSeparateAttendee }}
          </td>
          <td>
            {{ eventItem.UseRegistrationDateForInvoiceDueDate }}
          </td>
          <td>
            {{ eventItem.DaysAfterRegistrationDateForInvoiceDueDate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
